import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone'
import styled from 'styled-components'
import { COLORS } from 'utils'

import { IconStyles } from '../types'

export const CancelIconCustom = styled(CancelTwoToneIcon)<IconStyles>`
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  cursor: ${({ cursor, disabled }) =>
    cursor && !disabled ? cursor : 'default'};

  color: ${({ colorIcon }) => colorIcon || COLORS.black};
`

//  cursor: ${({ cursor }) => cursor || 'pointer'};
